import * as Switch from '@radix-ui/react-switch'
import clsx from 'clsx'
import {forwardRef, type ComponentProps, type ElementRef} from 'react'

export const Toggle = forwardRef<
  ElementRef<typeof Switch.Root>,
  ComponentProps<typeof Switch.Root>
>(function Toggle(props, ref) {
  return (
    <Switch.Root
      ref={ref}
      {...props}
      className={clsx(
        'w-10 h-6 bg-neutral-400 rounded-lg relative data-[state=checked]:bg-primary-800 outline-none cursor-default',
        'focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-primary-500/5',
      )}
    >
      <Switch.Thumb className="block size-5 bg-neutral-25 rounded-full shadow-md transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[18px]" />
    </Switch.Root>
  )
})
